<template>

    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner :admin="false" />
    </b-container>

    <b-container v-else  class="tt-container-main">

        <b-container class="tt-container-header">
            <b-row class="m-0">

                <b-col>
                    <b-row class="m-0 tt-row-header">
                        {{entity.MdRetailChainName}} {{ subType }}
                    </b-row>

                    <b-row class="m-0 gray roman">
                        {{entity.Address}}
                    </b-row>
                </b-col>

                <b-col v-if="!isFromForm"  cols="2" class="tt-view-icon-edit">
                    <span id="editTT" class="pointer" @click="openEditTT">
                        <font-awesome-icon icon="edit" class="icon-edit"/>
                    </span>
                </b-col>

            </b-row>

        </b-container>

        <b-container class="p-0 mt-30">

            <b-tabs fill class="tabs-view-TT">

                <b-tab title="Информация" id="infoTT">

                    <b-list-group class="shadow">

                        <b-list-group-item class="tt-list-item">
                        
                           <info-view :trade-point="entity"/>

                        </b-list-group-item>

                        <b-list-group-item v-if="!isFromForm" class="container-button">

                                <b-button   variant="outline-primary" 
                                          class="button-blue"
                                          @click="startVisit">
                                    Начать визит
                                </b-button>

                        </b-list-group-item>

                    </b-list-group>

                </b-tab>

                <b-tab title="Контакты">

                    <b-list-group class="shadow">

                        <b-list-group-item class="tt-list-item" v-if="entity.DaxContactList && entity.DaxContactList.length">

                            <dax-contacts-view :trade-point-dax-contacts="entity.DaxContactList"/>

                        </b-list-group-item>

                        <b-list-group-item v-else 
                                           class="tt-list-item stub-normal">
                            Торговая точка не имеет контактов
                        </b-list-group-item>

                        <b-list-group-item v-if="!isFromForm" class="container-button">

                            <b-button   variant="outline-primary" 
                                        class="button-blue"
                                        @click="startVisit">
                                Начать визит
                            </b-button>

                        </b-list-group-item>

                    </b-list-group>

                </b-tab>

                <b-tab title="ЛПР" id="contactsTT">

                    <b-list-group class="shadow">                        

                        <b-list-group-item v-if="entity.ContactList && entity.ContactList.length" class="tt-list-item">

                            <contacts-view :trade-point-contacts="entity.ContactList"/>

                        </b-list-group-item>

                        <b-list-group-item v-else 
                                           class="tt-list-item stub-normal">
                            Торговая точка не имеет ЛПР
                        </b-list-group-item>

                        <b-list-group-item v-if="!isFromForm" class="container-button">

                            <b-button   variant="outline-primary" 
                                        class="button-blue"
                                        @click="startVisit">
                                Начать визит
                            </b-button>

                        </b-list-group-item>

                    </b-list-group>

                </b-tab>

                

                <b-tab title="AEP'ы ТТ" v-if="isAdministrator && entity.AepList && entity.AepList.length">

                    <b-list-group class="shadow">

                        <b-list-group-item class="tt-list-item">

                            <aep-view :aep-model-list="entity.AepList"/>

                        </b-list-group-item>

                        <b-list-group-item v-if="!isFromForm" class="container-button">

                            <b-button   variant="outline-primary" 
                                        class="button-blue"
                                        @click="startVisit">
                                Начать визит
                            </b-button>

                        </b-list-group-item>

                    </b-list-group>

                </b-tab>

                <b-tab title='Сигналы "Магнит"' v-if="isAdministrator && entity.MagnitSignalList && entity.MagnitSignalList.length">

                    <b-list-group class="shadow">

                        <b-list-group-item class="tt-list-item">

                            <aep-view :aep-model-list="entity.MagnitSignalList"/>

                        </b-list-group-item>

                        <b-list-group-item v-if="!isFromForm" class="container-button">

                            <b-button   variant="outline-primary" 
                                        class="button-blue"
                                        @click="startVisit">
                                Начать визит
                            </b-button>

                        </b-list-group-item>

                    </b-list-group>

                </b-tab>


                <b-tab title="Задачи" id="taskTT" >

                    <b-container class="p-0" 
                                 :class="entity.TodoList && entity.TodoList.length ? 'mt-20' : ''">    

                        <span v-if="entity.TodoList && entity.TodoList.length">
                            <b-list-group-item button
                                            v-for="(item, index) in entity.TodoList" 
                                            :key="index"
                                            class="task"
                                            :class="item.IsActive ? 'active-task' : ''"
                                            @click="entity.showTask(item)">

                                <task-item :item="item" :is-view="true"/>

                            </b-list-group-item>
                        </span>

                        <b-list-group-item v-else 
                                           class="tt-list-item stub-normal">
                            Торговая точка не имеет задач
                        </b-list-group-item>

                        <b-list-group-item v-if="!isFromForm"  
                                           :id="entity.TodoList && entity.TodoList.length ? 'container-button-task' : ''" 
                                           class="container-button">

                            <b-button variant="outline-primary" 
                                        class="button-blue"
                                        @click="startVisit">
                                Начать визит
                            </b-button>

                        </b-list-group-item>

                    </b-container>

                </b-tab>

                <b-tab title="ТМА" id="TmpTt" v-if="isAdministrator && entity.TmaList.length">
                    <b-list-group class="shadow">

                        <b-list-group-item class="tt-list-item"
                                           v-for="(item, index) in entity.TmaList"
                                           :key="index">
                        
                            <tma-view :tma="item"/>

                        </b-list-group-item>

                        <b-list-group-item v-if="!isFromForm" class="container-button">

                            <b-button   variant="outline-primary" 
                                        class="button-blue"
                                        @click="startVisit">
                                Начать визит
                            </b-button>

                        </b-list-group-item>

                    </b-list-group>
                </b-tab>

            </b-tabs>

        </b-container>

    </b-container>

</template>
<script>
import '@/assets/styles/client/tradePoints/tradePointView.css'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import AllRotes from '@/routes/all.routes'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import TradePointViewModel from '@/store/models/client/tradePoints/TradePointViewEdit'

import InfoView from '@/components/client/tradePoints/view/InfoView'
import ContactsView from '@/components/client/tradePoints/view/ContactsView'
import DaxContactsView from '@/components/client/tradePoints/view/DaxContactsView'
import AepView from '@/components/client/tradePoints/view/AepView'
import TaskItem from '@/components/client/form/TaskItem'
import TmaView from '@/components/client/tradePoints/view/TmaView'

export default {
    computed: {
        subType: function() {
            return this.entity.SubType ? `, ${this.entity.SubType.Text}` : null;
        },
        isAdministrator: function() {
            return this.$store.getters.isAdministrator;
        }
    },
    data: function() {
        let load = new Loading();

        // если с экрана Выбор ТТ 
        let isFromTTs = Object.keys(this.$route.query).length == 2 && this.$route.query.id != undefined;
        let id = isFromTTs ? this.$route.query.id : null;

        // если с экрана Анкеты 
        let isFromForm = Object.keys(this.$route.query).length == 2 && this.$route.query.isEdit != undefined;

        if(id)
            this.getTradePoint(load, id);

      return {
          entity: null,
          load: load,

          
          isFromForm: isFromForm
      }  
    },
    created: function() {
        // если перешли с экрана редактирования
        if(Object.keys(this.$route.query).length == 1) {
            let storageTT = this.getStorage();
            this.entity = new TradePointViewModel(storageTT);
        }         
        
        // если перешли с экрана Анкеты
        
        if(this.isFromForm) {

            if(Object.keys(this.$route.params).length) {
                this.entity = this.$route.params.tradePoint;
                this.updateStorage();
            }  

            let storedTT = this.getStorage();
            this.entity = new TradePointViewModel({ ...this.$route.params.tradePoint, ...storedTT });
        }         
    },
    methods: {
        getStorage: function() {
            return JSON.parse(localStorage.getItem('trade.point'));
        },
        setStorage: function(value) {
            localStorage.setItem('trade.point', JSON.stringify(value));
        },
        updateStorage: function() {
            let storedTT = this.getStorage();
            if(!storedTT) storedTT = {};

            storedTT = JSON.parse(JSON.stringify(this.entity));
            this.setStorage(storedTT);
        },

        getTradePoint: function(load, id) {
            load.Calculate(true);

            apiService.Client.TradePoints.Get(id)
                .then(response => {
                    this.entity = new TradePointViewModel(response.data);
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },

        openEditTT: function() {
            this.$router.push({
                name: AllRotes.Client.TradePoints.Edit,
                params: { tradePointEdit: this.entity },
                query: {id: this.entity.Id, auditId: this.$route.query.auditId}
            });
        },

        startVisit: function() {
            if(this.entity.SegmentCode == 0) {
                dialogService.showAlert('Предупреждение', 'Сегмент торговой точки не заполнен');
                return;
            }        
            
            let ttDto = this.entity.mapToDto();
            
            this.load.Calculate(true);

            apiService.Client.Audit.PostAddTradePoint(this.$route.query.auditId, ttDto)
                .then(response => {
                    this.$router.push(`${AllRotes.Client.Form.Index}?id=${response.data}&auditId=${this.$route.query.auditId}`);
                })
                .catch(() => this.load.Calculate(false));
        }
    },
    components: {
        Spinner,
        InfoView,
        ContactsView,
        DaxContactsView,
        AepView,
        TaskItem,
        TmaView
    }    
}
</script>

<style>
.tabs-view-TT .nav-tabs .nav-link.active {
    color: #5b5959 !important;
    font-family: 'HelveticaNeueCyr-Medium';
    border-top: 6px solid #86BE44;
}
.tabs-view-TT .nav-tabs .nav-link:hover {
    color: #5b5959;
    border-bottom: none;
    border-top: 6px solid #e9ecef;
}

.tabs-view-TT .nav-tabs .nav-link {
    color: gray;
}

</style>